// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"499":"2d02b319","780":"467f69b2","802":"467f69b2","992":"467f69b2"}[chunkId] + ".chunk.css";
};